"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacer = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
function Spacer({ h, w }) {
    return (react_1.default.createElement(react_2.Spacer, { h: h || "0", maxH: h || "0", minH: h || "0", w: w || "0", maxW: w || "0", minW: w || "0" }));
}
exports.Spacer = Spacer;
//# sourceMappingURL=Spacer.js.map